import {useEffect} from 'react'
import classNames from 'classnames'

import {PACK_MODE} from '../../common/constants/PackingOrderModal.js'
import {
  setupPackShipPage,
  setPackShipLabelType,
  packShipOrderNumbersSelector,
  packShipIsLoadingSelector,
  packShipLabelTypeSelector,
  currentPackShipOrderNumberSelector,
  currentPackShipOrderNeedsContentsVerifiedSelector,
  currentPackShipOrderNeedsLabelSelector,
  currentPackShipOrderNeedsToPrintSelector,
  setupPackShipPageForm,
} from './packShipFunctions.js'

import NextBackCounter from './NextBackCounter.js'
import ScanToBegin from './ScanToBegin.js'
import OrderInfo from './OrderInfo.js'
import PackPanel from './PackPanel/index.js'
import LabelConfigPanel from './LabelConfigPanel.js'
import LabelViewForm from '../OrderListPage/LabelViewForm.js'
import DonePanel from './DonePanel.js'
import Modals from '../OrderListPage/Modals/index.js'
import {hasOrderPermissionSelector} from '../../data/me.js'
import NoPermissionsPage from '../NoPermissionsPage.js'
import {onlyIfAutoForm, useSelector} from '../../store.js'
import {
  LABEL_TYPE_RETURN,
  LABEL_TYPE_SHIPPING,
} from '../../common/constants/LabelConfig.js'
import {ensureReturnLabelInfos} from '../../data/labelInfos/index.js'

function PackShipPage() {
  const orderNumbers = useSelector(packShipOrderNumbersSelector)
  const isLoading = useSelector(packShipIsLoadingSelector)
  const labelType = useSelector(packShipLabelTypeSelector)
  const orderNumber = useSelector(currentPackShipOrderNumberSelector)
  const needsContentsVerified = useSelector(
    currentPackShipOrderNeedsContentsVerifiedSelector,
  )
  const needsLabel = useSelector(currentPackShipOrderNeedsLabelSelector)
  const needsToPrint = useSelector(currentPackShipOrderNeedsToPrintSelector)
  const hasOrderPermission = useSelector(hasOrderPermissionSelector)

  useEffect(() => {
    document.title = 'Scan/Verify Package Contents'
  }, [])

  useEffect(() => {
    setupPackShipPage()
  }, [orderNumbers])

  useEffect(() => {
    if (labelType !== LABEL_TYPE_RETURN) {
      return
    }

    ensureReturnLabelInfos(orderNumbers)
  }, [orderNumbers, labelType])

  if (!hasOrderPermission) {
    return <NoPermissionsPage />
  }

  if (isLoading) {
    return null
  }

  return (
    <div id="iverson-page" className="wrap--packship-page">
      <Modals />
      <div className="wrap--row">
        <div className="medium-10 medium-centered columns">
          <h2 className="fs-04 margin-top-20 align-center">
            Scan/Verify Package Contents
          </h2>
          {orderNumbers.length === 0 ? (
            <ScanToBegin className="margin-top-30" />
          ) : (
            <>
              <NextBackCounter />
              <div className="wrap--edit-form margin-top-20 margin-bottom-20">
                <div className="form__header--edit align-center flex--justify">
                  <p className="fs-03 margin-bottom-0">
                    <strong>Order:</strong> <span>{orderNumber}</span>
                  </p>
                  <DonePanel />
                </div>
                <div className="wrap--row flex">
                  <div className="medium-9 columns">
                    {needsContentsVerified && (
                      <PackPanel
                        orderNumbers={[orderNumber]}
                        mode={PACK_MODE}
                      />
                    )}

                    {!needsContentsVerified && (needsLabel || needsToPrint) && (
                      <div className="wrap--row">
                        <div className="medium-10 medium-centered columns">
                          <div className="panel--actions panel--order-action margin-top-10 margin-bottom-30">
                            <ul className="list--tabs flex-wrap clearfix">
                              <li
                                className={classNames('list__item--tab', {
                                  active: labelType === LABEL_TYPE_SHIPPING,
                                })}
                              >
                                <button
                                  className="btn btn--tab"
                                  type="button"
                                  onClick={() =>
                                    setPackShipLabelType(LABEL_TYPE_SHIPPING)
                                  }
                                >
                                  Shipping Label
                                </button>
                              </li>
                              <li
                                className={classNames('list__item--tab', {
                                  active: labelType === LABEL_TYPE_RETURN,
                                })}
                              >
                                <button
                                  className="btn btn--tab"
                                  type="button"
                                  onClick={() =>
                                    setPackShipLabelType(LABEL_TYPE_RETURN)
                                  }
                                >
                                  Return Label
                                </button>
                              </li>
                            </ul>
                            {(() => {
                              if (needsLabel) {
                                return (
                                  <LabelConfigPanel
                                    orderNumber={orderNumber}
                                    labelType={labelType}
                                  />
                                )
                              }
                              if (needsToPrint) {
                                return (
                                  <LabelViewForm
                                    orderNumbers={[orderNumber]}
                                    labelType={labelType}
                                    showSingleOrderNumber
                                  />
                                )
                              }
                            })()}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="medium-3 columns divider--left dark margin-top-10 margin-bottom-20 margin-right-0">
                    <OrderInfo />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default onlyIfAutoForm(PackShipPage, setupPackShipPageForm)
